module.exports = __webpack_public_path__ + "img/purple-t-shirt.da28e9e6.jpg";